import{a as e}from"./chunk-7AVNFPYP.js";import{a as c}from"./chunk-NSSZCJ4M.js";import{e as t}from"./chunk-FW5F5ZKG.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-YO5D3RWU.js.map
